import {PersonalLabel} from "../domain/entities/personal-label.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class UpdatePersonalLabelCommand extends AbstractCommand<PersonalLabel> {

    name = CommandName.UPDATE_PERSONAL_LABEL;

    tags = ['entity', 'update', 'personal-label'];

}
